import Meta from 'src/components/meta/Meta';

const ResetPasswordMeta = () => <Meta
  title="Forgotten your Password? | BrickX"
  description="You can reset the password to your BrickX account here. All you will need is the email address you signed up with."
/>;

export default ResetPasswordMeta;
